import React from "react";
import Skeleton from "react-loading-skeleton";
export const HighchartsTypeColumnSkeleton = () => {
  return (
    <div className="highcharts-skeleton-container">
      {/* Chart Title Skeleton */}
      {/* <div className="chart-title-skeleton">
          <Skeleton width={200} height={24} />
        </div> */}

      {/* Chart Legend Skeleton */}
      {/* <div className="chart-legend-skeleton">
          <Skeleton width={150} height={20} />
        </div> */}

      {/* Main Chart Area */}
      <div className="chart-area">
        {/* Y-axis labels */}
        <div className="y-axis">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="y-axis-label">
              <Skeleton width={40} height={15} />
            </div>
          ))}
        </div>

        {/* Chart content with grid lines */}
        <div className="chart-content">
          {/* Grid lines */}
          <div className="grid-lines">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="grid-line">
                <Skeleton width="100%" height={1} />
              </div>
            ))}
          </div>

          {/* Columns skeleton */}
          <div className="columns-container">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="column-wrapper">
                <Skeleton width={30} height={Math.random() * 100 + 50} />
              </div>
            ))}
          </div>

          {/* Line skeleton */}
          <div className="line-container">
            <Skeleton width="100%" height={2} />
          </div>
        </div>
      </div>

      {/* X-axis labels */}
      <div className="x-axis">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="x-axis-label">
            <Skeleton width={50} height={15} />
          </div>
        ))}
      </div>

      {/* Chart source/footer */}
      <div className="chart-footer d-flex justify-content-center">
        <Skeleton width={120} height={12} style={{ marginRight: "20px" }} />
        <Skeleton width={120} height={12} />
      </div>
    </div>
  );
};

const HighchartsTypeColumnSkeletonStyles = `
  .highcharts-skeleton-container {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    background: white;
    border-radius: 4px;
  }
  
  .chart-title-skeleton {
    margin-bottom: 15px;
  }
  
  .chart-legend-skeleton {
    margin-bottom: 20px;
  }
  
  .chart-area {
    display: flex;
    height: 120px;
    margin-bottom: 10px;
  }
  
  .y-axis {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 10px;
    width: 40px;
  }
  
  .chart-content {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .grid-lines {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .columns-container {
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    height: 100%;
    z-index: 1;
  }
  
  .column-wrapper {
    display: flex;
    align-items: flex-end;
    height: 100%;
  }
  
  .line-container {
    position: absolute;
    width: calc(100% - 60px);
    top: 50%;
    left: 30px;
    z-index: 2;
  }
  
  .x-axis {
    display: flex;
    justify-content: space-around;
    margin-top: 10px;
  }
  
  .chart-footer {
    margin-top: 15px;
    text-align: center;
  }
`;

// Add styles to the document head
const hcStyleElement = document.createElement("style");
hcStyleElement.innerHTML = HighchartsTypeColumnSkeletonStyles;
document.head.appendChild(hcStyleElement);

export const HighchartsTypeLineSkeleton = () => {
  return (
    <div className="line-chart-skeleton">
      {/* Chart Header */}
      {/* <div className="chart-header">
        <Skeleton width={250} height={28} style={{ marginBottom: "8px" }} />
        <Skeleton width={180} height={20} />
      </div> */}

      {/* Chart Body */}
      <div className="chart-body">
        {/* Y-axis */}
        <div className="y-axis">
          {[...Array(5)].map((_, i) => (
            <div key={`y-label-${i}`} className="y-axis-label">
              <Skeleton width={40} height={16} />
            </div>
          ))}
        </div>

        {/* Chart Content */}
        <div className="chart-content">
          {/* Grid Lines */}
          <div className="grid-lines">
            {[...Array(5)].map((_, i) => (
              <div key={`grid-line-${i}`} className="grid-line">
                <Skeleton width="100%" height={1} />
              </div>
            ))}
          </div>

          {/* Data Line Path */}
          <div className="line-path">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 500 300"
              preserveAspectRatio="none"
            >
              <Skeleton
                as="path"
                d="M0,250 C50,200 100,220 150,180 C200,140 250,160 300,120 C350,80 400,100 450,50"
                strokeWidth={3}
                height="100%"
                width="100%"
              />
            </svg>
          </div>

          {/* Data Points */}
          <div className="data-points">
            {[...Array(5)].map((_, i) => (
              <div
                key={`point-${i}`}
                className="data-point"
                style={{
                  left: `${(i / 5) * 100}%`,
                  top: `${Math.random() * 70 + 15}%`,
                }}
              >
                <Skeleton circle width={12} height={12} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* X-axis */}
      <div className="x-axis">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fir", "Sat"].map(
          (WeekDayName) => (
            <div key={WeekDayName} className="x-axis-label">
              <Skeleton width={40} height={16} />
            </div>
          )
        )}
      </div>

      {/* Chart Footer */}
      <div className="chart-footer">
        <Skeleton width={150} height={14} />
      </div>
    </div>
  );
};

// Styles
const HighchartsTypeLinekeletonStyle = `
  .line-chart-skeleton {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    background: white;
    border-radius: 4px;
  }
  
  .chart-header {
    margin-bottom: 15px;
    text-align: center;
  }
  
  .chart-body {
    display: flex;
    height: 120px;
    margin-bottom: 10px;
  }
  
  .y-axis {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 50px;
    padding-right: 10px;
  }
  
  .chart-content {
    flex: 1;
    position: relative;
  }
  
  .grid-lines {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .line-path {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  
  .data-points {
    position: absolute;
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    margin: 10px;
  }
  
  .data-point {
    position: absolute;
    transform: translate(-50%, -50%);
  }
  
  .x-axis {
    display: flex;
    justify-content: space-around;
    padding-top: 10px;
  }
  
  .chart-footer {
    text-align: center;
    margin-top: 16px;
    opacity: 0.7;
  }
`;

// Add styles to the document head
const styleElement = document.createElement("style");
styleElement.innerHTML = HighchartsTypeLinekeletonStyle;
document.head.appendChild(styleElement);
